// extracted by mini-css-extract-plugin
module.exports = {"action_container":"ScreenerSettingsActionsComponent_action_container__7CWvw","action":"ScreenerSettingsActionsComponent_action__1l6LT"};